import React, { useContext, createElement } from 'react'
import CardContext from 'context/card'
import classNames from 'classnames'

const Description = () => {
    /**
     * Description must support HTML (not just plain text).
     * If it is html, then set the dangerouslySetInnerHTML prop.
     * If it's not html, then create the element with children.
     * Can't set both the dangerouslySetInnerHTML and give children
     * or you will get an error.
     */

    const props = useContext(CardContext)
    
    const {
        product,
        descriptionHTML,
        descriptionClassName,
        descriptionStyle,
    } = props

    const description = product ? product?.description :
        props?.description ? props?.description :
        ''

    const descriptionProps = {
        style: descriptionStyle,
        className: classNames(
            'description',
            'clamp-2',
            descriptionClassName,
        ),
    }
    
    if (descriptionHTML) {
        descriptionProps.dangerouslySetInnerHTML = { 
            __html: descriptionHTML
        }
    }

    if(descriptionHTML){
        return createElement('p', descriptionProps)
    } else if(description) {
        return createElement('p', descriptionProps, description)
    }
}

export default Description
